import React from 'react';
import PT from 'prop-types';
import { Box, colors } from '@procore/core-react';
import styled from 'styled-components';

const FooterContainer = styled(Box)`
  background-color: ${colors.white};
  border-top: 1px solid ${colors.gray90};
`;

export const MobileOverlayFooter = ({ children }) => (
  <FooterContainer padding="xl">{children}</FooterContainer>
);

MobileOverlayFooter.propTypes = {
  children: PT.node.isRequired,
};
